<template>
<div>
  <top-nav ref="TopNav"></top-nav>
  <van-nav-bar title="我的积分" left-arrow @click-left="goBack" @click-right="onClickRight">
    <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
  </van-nav-bar>
  <van-cell-group>
    <div class="van-cell van-hairline">
      <div class="van-cell__title"><span>变动{{ configData.currency }}</span></div>
      <div class="van-cell__value"><span>{{ parseFloat(datas.point)+parseFloat(datas.bpoint) }}</span></div>
    </div>
    <div class="van-cell van-hairline">
      <div class="van-cell__title"><span>类型</span></div>
      <div class="van-cell__value"><span>{{ datas.type==1?'增加':'减少' }}</span></div>
    </div>
    <!--<div class="van-cell van-hairline">-->
      <!--<div class="van-cell__title"><span>当前余额</span></div>-->
      <!--<div class="van-cell__value"><span>{{ datas.member_point }}</span></div>-->
    <!--</div>-->
    <div class="van-cell van-hairline">
      <div class="van-cell__title"><span>操作时间</span></div>
      <div class="van-cell__value"><span>{{ datas.add_time }}</span></div>
    </div>
    <div class="van-cell van-hairline">
      <div class="van-cell__title"><span>备注</span></div>
      <div class="van-cell__value"><span>{{ datas.note }}</span></div>
    </div>
  </van-cell-group>
</div>
</template>

<script>
  import TopNav from '@/components/topnav'
  export default {
    name: "money",
    props:['configData'],
    components: {
      TopNav
    },
    data () {
      return {
        datas:[],
        id:this.$route.query.id
      }
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      getDatas: function () {
        var isUser = localStorage.getItem("BLHuser")
        var _this = this
        this.page++
        this.$api.post('WebApi/Member/Point/detail', {token:isUser,id:this.id}, res => {
          this.datas = res.data.data
        })
      },
    },
    mounted () {
          this.getDatas()
          localStorage.setItem("BLHUrl",window.location.href)
          var isUrl = localStorage.getItem("BLHUrl")
          console.log(isUrl);
    },
    beforeDestroy:function(){
      localStorage.setItem("BLHUrl",window.location.href)
      var isUrl = localStorage.getItem("BLHUrl")
      console.log(444);
      
    }
  }
</script>

<style scoped>
  .van-cell-group{
    background: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/mymoney/money.vue